// 导航栏菜单
const navMenu = {
    state: {
        menu: []
    },

    mutations: {
        SET_NAVMENU_MENU: (state, params) => {
            state.menu = params;
        }
    }
}

export default navMenu